import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaymentsRoutingModule } from './payments-routing.module';
import { PaymentsComponent } from './payments.component';
import { NgZorroAntdModule } from '../utilities/ng-zorro-antd.module';
import { RouterModule } from '@angular/router';
import { RequestPaymentComponent } from './request-payment/request-payment.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ViewRequestedPaymentComponent } from './request-payment/view-requested-payment/view-requested-payment.component';
import { RequestedPaymentComponent } from './requested-payment/requested-payment.component';
import { MomentModule } from 'ngx-moment';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';


@NgModule({
  declarations: [PaymentsComponent, RequestPaymentComponent, ViewRequestedPaymentComponent, RequestedPaymentComponent],
  imports: [
    CommonModule,
    NgZorroAntdModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    PaymentsRoutingModule,
    ReactiveFormsModule,
    MomentModule,
    NgxQRCodeModule
  ]
})
export class PaymentsModule { }
